module.exports = __webpack_public_path__ + "static/media/Danielle Green.9ac85780.png";